export const picklistTypes = {
  GET_PICK_LIST_DATA_SUCCESS: "GET_PICK_LIST_DATA_SUCCESS",
  GET_PICK_LIST_DATA_ERROR: "GET_PICK_LIST_DATA_ERROR",
  ADD_DOWNLOAD_PICK_LIST_DATA_ERROR: "ADD_DOWNLOAD_PICK_LIST_DATA_ERROR",
  REMOVE_DOWNLOAD_PICK_LIST_DATA_ERROR: "REMOVE_DOWNLOAD_PICK_LIST_DATA_ERROR",
  GET_ACTION_REQUEST_COUNT_SUCCESS: "GET_ACTION_REQUEST_COUNT_SUCCESS",
  GET_ACTION_REQUEST_COUNT_ERROR: "GET_ACTION_REQUEST_COUNT_ERROR",
};
